export default {
  getHead: () => {
    return [{name: '사업장명'}, {name: '업체명'}, {name: '요청자 소속명'}, {name: '요청자 부서명'}, {name: '작성자'}, {name: '작성일'}]
  } ,
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).inputC_1 // 사업명
        case 1: return func.getContent(value).inputC_2 // 업체명
        case 2: return func.getContent(value).inputB_1 // 요청자 소속명
        case 3: return func.getContent(value).inputB_2 // 요청자 부서명
        case 4: return value.user ? value.user.name : value.author.name // 작성자
        case 5: return func.getCreatedDate(value.created_at) // 작성일 // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = 'created_at'
      nav.dateBegin = 'nav.value.created_at.sDate'
      nav.dateEnd = 'nav.value.created_at.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
      case '사업명': returnData.push('content$body.inputC_1*%[:default_skw]%'); break
      case '업체명': returnData.push('content$body.inputC_2*%[:default_skw]%'); break
      case '요청자소속명': returnData.push('content$body.inputB_1*%[:default_skw]%'); break
      case '요청자부서명': returnData.push('content$body.inputB_2*%[:default_skw]%'); break
      case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    }

    return returnData
  },
}
